import stringToBoolean from '../../util/stringToBoolean';

let isProduction;
let ezRailsDomain;
let customerManagementHost;

// eslint-disable-next-line no-underscore-dangle
if (typeof window !== 'undefined' && window.__ENV__) {
  ({isProduction, ezRailsDomain, customerManagementHost} = window.__ENV__); // eslint-disable-line no-underscore-dangle
} else {
  const nodeEnv = process.env.NODE_ENV;
  const testEnvStr = process.env.TEST_ENV;
  const isTest = stringToBoolean(testEnvStr);

  isProduction = nodeEnv === 'production' && !isTest;
  ezRailsDomain = process.env.EZRAILS_DOMAIN;
  customerManagementHost = process.env.CUSTOMER_MANAGEMENT_HOST;
}

export const legacyIsProduction = isProduction;
export const legacyEzRailsDomain = ezRailsDomain;
export const legacyCustomerManagementDomain = customerManagementHost;
